// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__-P38Z","head":"ProcedureTableInfo_head__28tTC"};